import {useEffect, useRef, useState} from "react";
import {useConfig} from "../hooks/useConfig";
import useWindowDimensions from "../hooks/useWindowDimensions";

export default function LiveChatWidget({isOpen, setIsOpen}) {
    const config = useConfig();
    const iframeRef = useRef();
    const {width, height} = useWindowDimensions();
    const [isMobileLayout, setIsMobileLayout] = useState(width <= 640);
    const [iFrameSize, setIFrameSize] = useState({width: 366, height: 500});
    useEffect(() => {
        setIsMobileLayout(width <= 640);
    }, [width]);


    const postMobileMessage = () => {
        if (iframeRef.current?.contentWindow) {
            console.log(width, height);
            iframeRef.current.contentWindow.postMessage(
                {
                    subject: "SET_MOBILE_LAYOUT",
                    isMobile: isMobileLayout,
                },
                "*",
            );
        }
    };

    const postOpenChatMessage = () => {
        if (isOpen && iframeRef.current?.contentWindow) {
            iframeRef.current.contentWindow.postMessage(
                { subject: "OPEN_LIVE_CHAT" },
                "*",
            );
        }
    };

    useEffect(() => postOpenChatMessage(), [isOpen]);
    useEffect(() => postMobileMessage(), [isMobileLayout]);

    useEffect(() => {
        const handleCloseEvent = (event) => {
            const {data} = event;
            if (!data || typeof data !== 'object') return;

            if (data.subject === "CLOSE_LIVE_CHAT") {
                setIsOpen(false);
            } else if (data.subject === "RESIZE_LIVE_CHAT") {
                setIFrameSize({width: data.width ? data.width : 366, height: data.height ? data.height : 500 });
            }
        }

        if (isOpen) {
            window.addEventListener('message', handleCloseEvent);
        }

        return () => {
            window.removeEventListener('message', handleCloseEvent);
        }
    }, [isOpen]);


    return (
        <div
            style={{
                display: isOpen ? "block" : "none",
                width: isMobileLayout ? '100%' : iFrameSize.width,
                height: isMobileLayout ? '100%' : iFrameSize.height,
                //
                // width: iFrameSize.width,
                // height: iFrameSize.height,
                position: "fixed",
                inset: isMobileLayout ? 'auto 0 0 auto' : 'auto 10px 10px auto',
                zIndex: 1
            }}
        >
            <iframe
                ref={iframeRef}
                // id={id ?? undefined}
                src={config.live_chat_url}
                onLoad={() => {
                    postMobileMessage();
                    postOpenChatMessage();
                }}
                style={{
                    display: isOpen ? "block" : "none",
                    width: "100%",
                    height: "100%",
                    border: "0",
                }}
            />
        </div>
    );
}